

















































import Vue from 'vue';
import * as prestazioneApi from '../services/prestazione-api';
import { PrestazioneList, PrestazioniViewModel } from '../types';

export default Vue.extend({
    components: {},
    data(): PrestazioniViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.numero-sinistro'),
                    value: 'displayName',
                },
                {
                    text: this.$i18n.t('labels.data-evento'),
                    value: 'dataEvento',
                },
                {
                    text: this.$i18n.t('labels.paziente'),
                    value: 'paziente',
                },
                {
                    text: this.$i18n.t('labels.avvocato'),
                    value: 'avvocato',
                },
                {
                    text: this.$i18n.t('labels.stato'),
                    value: 'ultimoStato',
                },
                {
                    text: this.$i18n.t('labels.compagnia-assicurativa'),
                    value: 'compagniaAssicurativa',
                },
                {
                    text: this.$i18n.t('labels.ente-sanitario'),
                    value: 'enteSanitario',
                },
                {
                    text: this.$i18n.t('labels.operatore-sanitario'),
                    value: 'operatoreSanitario',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await prestazioneApi.getList(
                this.$route.params.statusId
            );
        },
        showDetail(item: PrestazioneList) {
            this.$router.push({
                name: 'PrestazioneDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await prestazioneApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },
    async mounted() {
        await this.loadData();
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
    },
});
